import Swiper from 'swiper';

export default class Newsblock {
  constructor() {
    this.mSwiper = false;
    this.modifyDOM();
    this.addEvents();
  }

  modifyDOM() {
    this.initSlider();
  }

  addEvents() {
  }

  initSlider() {
    this.mSwiper = new Swiper('.news-block-container', {
      loop: false,
      slidesPerView: 'auto',
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
        renderFraction: (currentClass, totalClass) => `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`,
      },
    });
  }
}
